import React, { useState, useEffect } from 'react';
import './styles.css';
import {
  Card,
  Row,
  Col,
  Form,
  Button,
  Input,
} from 'antd';
import Logo from '@BUP/assets/Images/bup_logo.png';
import { ReactComponent as GoogleIcon } from '@BUP/assets/Icons/googleIcon.svg';
import { useAuth } from '@BUP/hooks';


const LoginPage = () => {
  const [form] = Form.useForm();
  const [, forceUpdate] = useState();
  const [error, setError] = useState(null);
  const { signIn, signInProvider } = useAuth();

  useEffect(() => {
    forceUpdate({});
  }, []);

  const onSubmit = async (values) => {
    try {
      const { email, password } = values;
      await signIn(email, password);
      form.resetFields();
      setError(null);
    } catch (e) {
      console.log("Login error", e);
      setError(e);
    }
  };

  const singInWhitGoogle = async (values) => {
    try {
      await signInProvider('google');
      form.resetFields();
      setError(null);
    } catch (e) {
      console.log("singInWhitGoogle error", e);
      setError(e);
    }
  };

  return (
    <div className="login-page-container">
      <div className="logo-wrapper">
        <img
          id="bup-logo"
          alt="BraveUp-Logo"
          src={Logo}
          style={{
            width: 300,
            height: 45,
          }}
        />
      </div>
      <div className="card-container">
        <Card
          className="login-card"
          bodyStyle={{ padding: 0 }}
        >
          <Row>
            <Col xs={24} className="card-header-wrapper">
              Te damos la bienvenida a BRAVE UP! <br />
              Por favor ingresa tus datos para iniciar sesión
            </Col>
            {
              error && error?.message ? (
                <Col xs={24} className="card-error-wrapper">
                  <span>{error?.message}</span>
                </Col>
              ) : null
            }
            <Col xs={24} className="card-form-wrapper">
              <Form layout="vertical" form={form} onFinish={onSubmit}>
                <Form.Item
                  label="Correo Electrónico"
                  name="email"
                  rules={[
                    {
                      required: true,
                      message: "Email requerido.",
                    },
                    {
                      required: true,
                      type: "email",
                      message: "El email no es valido."
                    }
                  ]}
                >
                  <Input
                    size="large"
                    placeholder="micorreo@braveup.com"
                  />
                </Form.Item>
                <Form.Item
                  label="Contraseña"
                  name="password"
                  rules={[
                    {
                      required: true,
                      message: "Contraseña requerida.",
                    },
                  ]}
                >
                  <Input.Password size="large" placeholder="*********" />
                </Form.Item>
                <Form.Item shouldUpdate={true}>
                  {() => (
                    <Button
                      type="primary"
                      block={true}
                      style={{ borderRadius: '0px' }}
                      size="large"
                      ghost={true}
                      htmlType="submit"
                      disabled={
                        form
                          .getFieldsError()
                          .filter(({ errors }) => errors.length).length
                      }
                    >
                      Iniciar Sesión
                    </Button>
                  )}
                </Form.Item>
              </Form>
            </Col>
            <Col xs={24} className="card-header-wrapper">
              <Button
                type="primary"
                ghost={true}
                block={true}
                size="large"
                style={{ display: 'flex', justifyContent: 'center' }}
                onClick={singInWhitGoogle}
              >
                <GoogleIcon
                  style={{ width: 24, height: 24, marginLeft: -10, marginRight: 10 }}
                />
                Ingresar con Google
              </Button>
            </Col>
            <Col xs={24} className="card-header-wrapper password-reset-wrapper">
              <a href="/password-reset">¿Has olvidado tu contraseña?</a>
            </Col>
          </Row>
        </Card>
      </div>
    </div>
  )
}

export default LoginPage;